<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-boxes"></i> ใบขอซื้อ</h4>

          <b-card no-body>
            <b-tabs
              card
              v-model="tabIndex"
              @input="onTabChange"
            >
              <!-- ───────── MRP tab ───────── -->
              <b-tab>
                <template #title>
                  ใบวางแผนความต้องการวัสดุ ({{ getMrpLength }})
                  <span
                    v-if="showMrpRedDot"
                    class="tab-red-dot"
                  ></span>
                </template>
                <div
                  class="row"
                  style="margin: 0px 0px 20px 0px"
                >
                  <b-form-input
                    type="search"
                    class="col"
                    autofocus
                    v-model="filter"
                    placeholder="ค้นหารหัสใบวางแผนความต้องการวัสดุ"
                  ></b-form-input>
                </div>
                <b-table
                  id="mrpTable"
                  ref="mrpTable"
                  hover
                  small
                  sort-icon-left
                  head-variant="light"
                  sort-by="creationDt"
                  :items="getMrpList"
                  :fields="mrpFields"
                  :filter="filter"
                  :filter-included-fields="['no']"
                  :sort-desc="true"
                  :sort-compare="mrpSortCompare"
                  :responsive="true"
                >
                  <template v-slot:cell(index)="row"
                    >{{ row.index + 1 }}.</template
                  >
                  <template v-slot:cell(no)="row">
                    {{ row.item.no }}
                  </template>
                  <template v-slot:cell(creationDt)="row">{{
                    formatDate(row.item.creationDt)
                  }}</template>

                  <template v-slot:cell(buttons)="row">
                    <div class="action-button-group">
                      <ActionButtonGroup
                        :item="row.item"
                        :show-delete="false"
                        :show-edit="false"
                        :show-info="true"
                        infoTooltip="ดูข้อมูลใบวางแผน<br />ความต้องการวัสดุ"
                        @info="openMrpDetailItemModal(row.item)"
                      />
                      <b-button
                        class="text-nowrap"
                        variant="primary"
                        @click="openMrpToCreateModal(row.item)"
                      >
                        แปลงเป็นใบขอซื้อ
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-tab>

              <!-- ───────── PR: รออนุมัติ (DRAFT) ───────── -->
              <b-tab>
                <template #title>
                  ใบขอซื้อรออนุมัติ ({{ pendingPrList.length }})
                  <span
                    v-if="showPrPendingRedDot"
                    class="tab-red-dot"
                  ></span>
                </template>
                <PrListTab
                  table-id="prDraftTable"
                  :items="pendingPrList"
                  :filter="filter"
                  :show-edit="true"
                  @update:filter="filter = $event"
                  @add-pr="openStandalonePrModal"
                  @edit="openPrToEditModal"
                  @info="navigateToPrDetail"
                />
              </b-tab>

              <!-- ───────── PR: อนุมัติแล้ว ───────── -->
              <b-tab title="ใบขอซื้ออนุมัติแล้ว">
                <PrListTab
                  table-id="prApprovedTable"
                  :items="approvedPrList"
                  :filter="filter"
                  :show-edit="false"
                  @update:filter="filter = $event"
                  @add-pr="openStandalonePrModal"
                  @info="navigateToPrDetail"
                />
              </b-tab>

              <!-- ───────── PR: ถูกยกเลิก ───────── -->
              <b-tab title="ใบขอซื้อถูกยกเลิก">
                <PrListTab
                  table-id="prCancelledTable"
                  :items="cancelledPrList"
                  :filter="filter"
                  :show-edit="false"
                  @update:filter="filter = $event"
                  @add-pr="openStandalonePrModal"
                  @info="navigateToPrDetail"
                />
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
      <CreateOrUpdatePurchaseReuqestModel
        ref="createOrUpdatePurchaseReuqestModel"
        @success="$refs.mrpDetailModal.close()"
      />
      <MrpDetailModal
        ref="mrpDetailModal"
        @convert="openCreateOrUpdatePurchaseReuqestModal"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Dialog from "../../components/modal/Dialog.vue";
import Loading from "@/components/Loading";
import { mapActions, mapGetters } from "vuex";
import ActionButtonGroup from "@/components/table/stock/button/ActionButtons.vue";
import { Status, PR_STATUS } from "../../constants/productStock";
import CreateOrUpdatePurchaseReuqestModel from "@/components/modal/ProductAndStock/PurchaseReuqest/CreateOrUpdatePurchaseReuqestModel.vue";
import MrpDetailModal from "@/components/modal/ProductAndStock/PurchaseReuqest/MrpDetailModal.vue";
import PrListTab from "@/components/ProductAndStock/PrListTab.vue";
import { ROLES } from "@/constants/user";

export default {
  name: "TransferInventory",
  components: {
    Dialog,
    Loading,
    ActionButtonGroup,
    CreateOrUpdatePurchaseReuqestModel,
    MrpDetailModal,
    PrListTab,
  },
  data() {
    const saved = sessionStorage.getItem("purchaseRequestTab");
    const tabMap = { "pr-pending": 1, "pr-approved": 2, "pr-cancelled": 3 };
    return {
      ROLES,
      isLoading: false,
      mrpFields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "6%" },
          tdStyle: { width: "6%" },
        },
        {
          key: "no",
          label: "รหัสใบวางแผนความต้องการวัสดุ",
          sortable: true,
          thStyle: { width: "50%" },
          tdStyle: { width: "50%" },
        },
        {
          key: "creationDt",
          label: "วันที่ทำรายการ",
          sortable: true,
          thStyle: { width: "10%" },
          tdStyle: { width: "10%" },
        },
        {
          key: "buttons",
          label: "",
          class: "text-center",
          thStyle: { width: "20%" },
          tdStyle: { width: "20%" },
        },
      ],
      Status,
      tabIndex: tabMap[saved] ?? 0,
    };
  },
  async mounted() {
    this.isLoading = true;
    try {
      const clinicUrl = this.$route.params.clinicUrl;
      const branchUrl = this.$route.params.branchUrl;
      await Promise.all([
        this.fetchMrpList({ clinicUrl, branchUrl }),
        this.fetchPurchaseRequests({ clinicUrl, branchUrl }),
      ]);
    } catch (err) {
      this.showDialogToast("danger", "โหลดข้อมูลไม่สำเร็จ");
      console.error(err);
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters({
      getMrpList: "moduleMrp/getMrpList",
      getMrpLength: "moduleMrp/getMrpLength",
      isShowRedDot: "moduleMrp/isShowRedDot",
      isPendingRedDot: "modulePurchaseRequest/isPendingRedDot",
      getPrList: "modulePurchaseRequest/getPrList",
      getProductList: "moduleProductInventory/getProductList",
      getPrFilter: "modulePurchaseRequest/getPrFilter",
      getIsAccessMenu: "moduleUser/getIsAccessMenu",
    }),
    filter: {
      get() {
        return this.getPrFilter;
      },
      set(value) {
        this.$store.commit("modulePurchaseRequest/setFilter", value);
      },
    },
    pendingPrList() {
      return (this.getPrList || []).filter(pr => pr.status === PR_STATUS.DRAFT);
    },
    approvedPrList() {
      const approved = [
        PR_STATUS.SENT_TO_ERP,
        PR_STATUS.PARTIALLY_ORDERED,
        PR_STATUS.CLOSED,
      ];
      return (this.getPrList || []).filter(pr => approved.includes(pr.status));
    },
    cancelledPrList() {
      return (this.getPrList || []).filter(
        pr => pr.status === PR_STATUS.CANCELED
      );
    },
    // Red dot logic: MRP dot only for ROLE_STOCK_STAFF, suppressed if user also has higher ROLE_BRANCH_STOCK_MANAGER
    showMrpRedDot() {
      return (
        this.isShowRedDot &&
        this.getIsAccessMenu([ROLES.ROLE_STOCK_STAFF]) &&
        !this.getIsAccessMenu([ROLES.ROLE_BRANCH_STOCK_MANAGER])
      );
    },
    // Red dot logic: PR pending dot only for ROLE_BRANCH_STOCK_MANAGER
    showPrPendingRedDot() {
      return (
        this.isPendingRedDot &&
        this.getIsAccessMenu([ROLES.ROLE_BRANCH_STOCK_MANAGER])
      );
    },
  },
  methods: {
    ...mapActions({
      fetchPurchaseRequests: "modulePurchaseRequest/fetchPurchaseRequests",
      fetchPrById: "modulePurchaseRequest/fetchPrById",
      fetchMrpList: "moduleMrp/fetchMrpList",
      fetchMrpById: "moduleMrp/fetchMrpById",
      fetchProductList: "moduleProductInventory/fetchProductList",
      isAccessMenu: "moduleUser/getIsAccessMenu",
    }),
    onTabChange(index) {
      const keys = ["mrp", "pr-pending", "pr-approved", "pr-cancelled"];
      sessionStorage.setItem("purchaseRequestTab", keys[index] || "mrp");
      this.filter = "";
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    formatDate(date) {
      return date ? moment(date).locale("th").format("DD MMM YY") : "";
    },
    navigateToPrDetail(item) {
      this.$router.push({
        name: "PurchaseRequestDetail",
        params: {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          prId: item.id,
        },
      });
    },
    openCreateOrUpdatePurchaseReuqestModal(mrpDetail) {
      this.$refs.createOrUpdatePurchaseReuqestModel.show({
        mrpNo: mrpDetail.no,
        mrpId: mrpDetail.id,
        products: mrpDetail.products || [],
        productList: this.getProductList,
        type: "CREATE",
      });
    },
    openMrpToCreateModal(item) {
      this.isLoading = true;
      this.fetchMrpById({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
        id: item.id,
      })
        .then(mrpDetail => {
          this.openCreateOrUpdatePurchaseReuqestModal(mrpDetail);
        })
        .catch(err => {
          console.error("fetchMrpById failed", err);
          this.showDialogToast("danger", "โหลดข้อมูลไม่สำเร็จ");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    openPrToEditModal(item) {
      this.isLoading = true;
      this.fetchPrById({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
        id: item.id,
      })
        .then(prDetail => {
          this.$refs.createOrUpdatePurchaseReuqestModel.show({
            prId: item.id,
            mrpNo: prDetail.mrpNo,
            mrpId: prDetail.mrpId,
            products: prDetail.products || [],
            productList: this.getProductList,
            type: "UPDATE",
          });
        })
        .catch(err => {
          console.error("fetchPrById failed", err);
          this.showDialogToast("danger", "โหลดข้อมูลไม่สำเร็จ");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async openStandalonePrModal() {
      this.isLoading = true;
      try {
        const clinicUrl = this.$route.params.clinicUrl;
        const branchUrl = this.$route.params.branchUrl;
        if (!this.getProductList?.length) {
          await this.fetchProductList({ clinicUrl, branchUrl });
        }
        this.$refs.createOrUpdatePurchaseReuqestModel.show({
          mrpNo: null,
          mrpId: null,
          products: [],
          productList: this.getProductList,
          type: "CREATE",
        });
      } catch (err) {
        console.error("openStandalonePrModal failed", err);
        this.showDialogToast("danger", "โหลดข้อมูลไม่สำเร็จ");
      } finally {
        this.isLoading = false;
      }
    },
    mrpSortCompare(a, b, key) {
      if (key === "creationDt") {
        const diff = new Date(a.creationDt) - new Date(b.creationDt);
        if (diff !== 0) return diff;
        return (a.no ?? "").localeCompare(b.no ?? "", undefined, {
          numeric: true,
        });
      }
      return null;
    },
    openMrpDetailItemModal(item) {
      this.isLoading = true;
      this.fetchMrpById({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
        id: item.id,
      })
        .then(mrpDetail => {
          this.$refs.mrpDetailModal.show(mrpDetail);
        })
        .catch(err => {
          console.error("fetchMrpById failed", err);
          this.showDialogToast("danger", "โหลดข้อมูลไม่สำเร็จ");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.tab-red-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #dd3333;
  border-radius: 50%;
  vertical-align: center;
}

::v-deep #mrpTable thead tr th,
::v-deep #mrpTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #mrpTable td {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #mrpTable th {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

.action-button-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
</style>
